<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="培训项目"
        left-text="返回"
        left-arrow
        fixed
        @click-left="goBack('/user')"
      />
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-image width="100%" :height="imgH" :src="imgPath(obj.pic)" />
        <van-cell-group title="项目名称">
          <h4 class="detail-title">{{ obj.title }}</h4>
        </van-cell-group>
        <van-cell-group title="项目介绍">
          <div class="detail-content">{{ obj.content }}</div>
        </van-cell-group>
        <van-cell-group title="项目科目">
          <template v-for="item in obj.list">
            <van-cell :key="item.id" :title="item.name">
              <div class="prices">
                <span v-if="item.market" class="market" v-html="webPrice(item.market)"></span>
                <span class="price" v-html="webPrice(item.price)"></span>
              </div>
            </van-cell>
          </template>
        </van-cell-group>
      </van-pull-refresh>
      <div class="detail-btns">
        <van-button v-if="obj.enabled" round block plain type="primary" @click="$router.push('/signup/'+ id)">
          去报名
        </van-button>
        <van-tag v-else color="#ccc" text-color="#fff">报名关闭</van-tag>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import mixin from '../mixin';
export default {
  components: {
  },
  mixins: [tools, mixin],
  props: {
    id: String
  },
  data() {
    return {
      error: false,
      isLoading: false,
      obj: {},
      stu: {},
    }
  },
  computed: {
    ...mapGetters([]),
    imgH() {
      if (!this.w) {
        return '33vw';
      }
      return this.w * 0.5;
    }
  },
  watch: {
    id() {
      this.loadData();
    }
  },
  created () {
    this.loadData();
  },
  mounted () {
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.obj = {};
      this.stu = {};
      this.doPost({
        url: 'site/home/item/'+ this.id,
        data: {},
        okcb: (json) => {
          this.obj = Object.assign({}, json);
          if (callback) {
            callback();
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData(() => {
        this.$toast('刷新成功');
      });
    },
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-top:46px;
  padding-bottom:5.2rem;
  /deep/ .detail-title {
    margin:0;
  }
  /deep/ .detail-title,
  /deep/ .detail-content {
    padding:1rem;
  }
  /deep/ .detail-content {
    white-space:pre-wrap;
  }
  .prices {
    .market {
      display: inline-block;
      margin-right:.25rem;
      padding:0 .25rem;
      text-decoration: line-through;
      color:#aaa;
      small {
        .fontsize(.8rem);
      }
    }
    .price {
      display: inline-block;
      color: #ff6600;
      .fontsize(1.2rem);
      small {
        .fontsize(.85rem);
      }
    }
  }
}
.detail-btns {
  position:fixed;
  left:1rem;
  bottom: 1rem;
  right:1rem;
  .flex-center();
  /deep/ .van-button--normal {
    .fontsize(1.2rem);
  }
}
</style>